var map = {
	"./img/eagle.svg": "ce68",
	"./img/hero-illustration.svg": "ff17",
	"./img/projects/ecologic-web.png": "2ca9",
	"./img/projects/ecologic.png": "2ee2",
	"./img/projects/galvanic.png": "da6c",
	"./img/projects/mediaplayer.png": "f01c",
	"./img/projects/preview/ecologic-web.png": "1f14",
	"./img/projects/preview/ecologic.png": "7e85",
	"./img/projects/preview/galvanic.png": "0a94",
	"./img/projects/preview/mediaplayer.png": "1b16",
	"./img/projects/preview/xchange.png": "3c6f",
	"./img/projects/xchange.png": "dfcc",
	"./scss/base/_base.scss": "c60d",
	"./scss/components/_buttons.scss": "4efd",
	"./scss/components/_components.scss": "90ce",
	"./scss/components/_project-card.scss": "3e3b",
	"./scss/components/_tag.scss": "4f28",
	"./scss/config/_config.scss": "2e52",
	"./scss/config/_variables.scss": "64c0",
	"./scss/layout/_layout.scss": "4686",
	"./scss/main.scss": "c1c3",
	"./scss/theme/_theme.scss": "3727"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";